import { HttpError, useEffectOnce } from "esa-hooks";
import { useVersion } from "hooks/useVersion";
import { useSafeEsaLogger } from "routes/protections/RequireEsaLogger";

// エラーが起きた時点で描画される要素から呼ぶこと(記録するのはマウント時の 1 回だけ)
export const useLogUnexpectedError = (error: unknown): void => {
  const logger = useSafeEsaLogger();
  const { refreshRequired } = useVersion();

  useEffectOnce(() => {
    // API 側でエラーログが出力されているエラーはフロントではロギングしない
    if (error instanceof HttpError) {
      return;
    }
    if (logger != null) {
      logger.error("Unexpected error", { e: error, refreshRequired });
    }
  });
};
